import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Smile } from "lucide-react";

const GROUPS = {
  Smileys: ["😀", "😃", "😄", "😁", "😆", "😅", "😂", "🙂", "😉", "😊", "😍", "😎", "🤔", "😐", "😬", "😴", "🤒", "😷", "😤", "😡", "😢", "😭", "🥳", "🤝"],
  Gestures: ["👍", "👎", "👌", "✌️", "🤞", "👏", "🙌", "🙏", "💪", "👋", "🫡", "✋", "☝️", "👉", "👈", "🤙"],
  Work: ["✅", "❌", "⚠️", "❗", "❓", "📋", "📄", "📎", "📅", "⏰", "📞", "📧", "💬", "🔔", "🔒", "✍️", "📝", "🗂️", "💰", "🧾"],
  Trucking: ["🚛", "🚚", "🛣️", "⛽", "🛞", "🚧", "🏁", "🗺️", "📍", "🧭", "🚦", "🏢", "🔧", "🛠️", "🩺", "🧪"],
  Misc: ["❤️", "🔥", "⭐", "🎉", "☕", "🍩", "🌟", "💯", "🙈", "🤷", "🤦", "🙋"],
};

export function EmojiPicker({ onPick }) {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" className="inline-flex items-center justify-center h-10 w-10 rounded-md border border-slate-200 bg-white hover:bg-slate-50 text-slate-600" title="Add emoji" data-testid="chat-emoji-button"><Smile className="h-4 w-4" /></button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-72 p-2 max-h-72 overflow-y-auto" data-testid="chat-emoji-picker">
        {Object.entries(GROUPS).map(([g, list]) => (
          <div key={g} className="mb-2">
            <div className="tag-mono text-slate-500 px-1 mb-1">{g.toUpperCase()}</div>
            <div className="grid grid-cols-8 gap-0.5">
              {list.map((e) => <button key={e} type="button" className="h-8 w-8 rounded hover:bg-slate-100 text-lg leading-none" onClick={() => { onPick(e); setOpen(false); }} data-testid={`emoji-${e}`}>{e}</button>)}
            </div>
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
}
